#!/usr/bin/env node
/**
 * BaskReport AI 报表生成器 CLI 入口。
 * 子命令：generate / datasource / report。
 */

import { Command } from 'commander';
import { registerGenerate } from './generate.js';
import { registerDatasource } from './datasource.js';
import { registerReport } from './report.js';
import { registerInstall } from './install.js';
import { registerUninstall } from './uninstall.js';
import { applyConfigDir } from '../core/config.js';

const program = new Command();
program
  .name('baskreport')
  .description('BaskReport AI 报表生成器：JSON 中间层 → XML → 服务端/离线文件')
  .version('0.1.0')
  .option(
    '--config-dir <dir>',
    '显式指定配置查找目录（含 .env / baskreport.config.json）；AI client 注入最可靠，优先级高于 cwd 自动探测',
  );

registerGenerate(program);
registerDatasource(program);
registerReport(program);
registerInstall(program);
registerUninstall(program);

// 在解析后立即把全局 --config-dir 注入配置查找目录（子命令 action 也会再次调用，幂等）。
applyConfigDir(program.opts() as { configDir?: string });

program.parseAsync(process.argv).catch((e) => {
  console.error(e?.message ?? e);
  process.exit(1);
});
